import { z } from 'zod';
import { post } from '@namespace/helpers';
import { validateScheme } from '@namespace/helpers/src/utils/validateSchema';

const LeaderboardUnsubscribeResponseSchema = z.object({
  status: z.enum(['success', 'error']),
  data: z.array(z.unknown())
});

type LeaderboardUnsubscribeResponse = z.infer<
  typeof LeaderboardUnsubscribeResponseSchema
>;

export const leaderboardUnsubscribe = (
  id: number | string
): Promise<LeaderboardUnsubscribeResponse> =>
  post<LeaderboardUnsubscribeResponse>(
    `/service/tournaments/tournaments/${id}/leaderboard/unsubscribe`
  ).then((response) => {
    validateScheme(LeaderboardUnsubscribeResponseSchema, response, {
      name: 'leaderboardUnsubscribe'
    });

    return response;
  });
